import React, { useContext } from "react";
import { AppContext } from "../App";
import { 
  IoCodeSlashOutline, 
  IoReceiptOutline,
  IoBusinessOutline
} from "react-icons/io5";

// Using your assets
import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/tax.jpg";
import banner3 from "../assets/erp.jpg";

export default function HomeServices() {
  const appContext = useContext(AppContext);

  const services = [
    { 
      title: "Software Development", 
      link: "werenium.com/software",  
      desc: "Comprehensive Native & Hybrid solutions spanning across Mobile, Web, and tailored Systems.", 
      icon: <IoCodeSlashOutline />, 
      img: banner1, 
      tag: "Development",
      subItem: "software" // Simple name for navigation
    },
    { 
      title: "Tax Compliance", 
      link: "werenium.com/tax",  
      desc: "Automated fiscal solutions and digital auditing tools to keep your business regulation-ready.", 
      icon: <IoReceiptOutline />, 
      img: banner2, 
      tag: "Financial",
      subItem: "tax-compliance" // Simple name for navigation
    },
    { 
      title: "Enterprise Solutions", 
      link: "werenium.com/bizsuite",  
      desc: "Our flagship BizSuite ecosystem: Scalable ERP and CRM tools built for high-level business logic.", 
      icon: <IoBusinessOutline />, 
      img: banner3, 
      tag: "Enterprise",
      subItem: "enterprise" // Simple name for navigation
    }
  ];

  return (
    <>
      <style>{`
        .w-services-section {
          padding: 140px 0;
          background: var(--bg-primary, #0a1118);
          overflow: hidden;
        }

        .w-container {
          max-width: 1300px;
          margin: 0 auto;
          padding: 0 40px;
        }

        .w-header-title {
          font-size: clamp(2.4rem, 6vw, 4.8rem);
          font-weight: 900;
          line-height: 1;
          letter-spacing: -0.06em;
          color: #fff;
          margin-bottom: 80px;
          font-family: 'Inter', system-ui, sans-serif;
        }

        .w-services-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
          gap: 40px;
        }

        .w-service-card {
          position: relative;
          height: 480px;
          background: #111d29;
          border-radius: 24px;
          overflow: hidden;
          cursor: pointer;
          border: 1px solid rgba(255, 255, 255, 0.05);
          transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .w-card-img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          opacity: 0.3;
          filter: grayscale(100%);
          transition: 0.8s ease;
          z-index: 0;
        }

        .w-card-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to bottom,
            rgba(10, 17, 24, 0.2) 0%,
            rgba(10, 17, 24, 0.95) 80%
          );
          z-index: 1;
        }

        .w-service-card::after {
          content: "";
          position: absolute;
          inset: 0;
          border-radius: 24px;
          padding: 2px;
          background: linear-gradient(135deg, var(--text-primary), transparent, transparent);
          -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          opacity: 0.2;
          transition: 0.5s;
        }

        .w-service-card:hover {
          border-color: rgba(22, 50, 79, 0.5);
          transform: translateY(-12px);
        }

        .w-service-card:hover .w-card-img {
          opacity: 0.6;
          filter: grayscale(0%);
          transform: scale(1.08);
        }

        .w-service-card:hover::after {
          opacity: 1;
          background: linear-gradient(135deg, var(--text-primary), #fff);
        }

        .w-card-inner {
          position: relative;
          z-index: 2;
          height: 100%;
          padding: 50px 40px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
        }

        .w-icon-container {
          width: 64px;
          height: 64px;
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          color: #fff;
          margin-bottom: auto;
          transition: 0.4s;
        }

        .w-service-card:hover .w-icon-container {
          background: var(--text-primary);
          color: #fff;
          box-shadow: 0 0 30px rgba(22, 50, 79, 0.4);
        }

        .w-service-title {
          font-size: 1.8rem;
          font-weight: 900;
          color: #fff;
          margin-bottom: 15px;
          letter-spacing: -0.03em;
        }

        .w-service-desc {
          font-size: 1rem;
          color: rgba(255, 255, 255, 0.5);
          line-height: 1.6;
          margin-bottom: 30px;
        }

        @media (max-width: 768px) {
          .w-services-grid { grid-template-columns: 1fr; }
          .w-container { padding: 0 25px; }
          .w-service-card { height: 420px; }
        }
      `}</style>

      <section className="w-services-section">
        <div className="w-container">
          
          <header className="">
            <h2 className="w-header-title text-secondary">Our Key Services.</h2>
          </header>

          <div className="w-services-grid mt-5">
            {services.map((service, index) => (
              <div 
                key={index} 
                className="w-service-card"
                onClick={() => appContext.navTo({ item: "services", subItem: service.subItem })}
              >
                <img src={service.img} className="w-card-img" alt={service.title} />
                <div className="w-card-overlay" />
                
                <div className="w-card-inner">
                  <div className="w-icon-container">
                    {service.icon}
                  </div>
                  
                  <div>
                    <h3 className="w-service-title">{service.title}</h3>
                    <p className="w-service-desc">{service.desc}</p>
                    <button 
                      className="btn btn-light"
                      style={{ border: 'none', cursor: 'pointer' }}
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}